<mat-drawer-container [class]="isMenuOpen() ? 'side-nav__open' : 'side-nav__closed'">
    <mat-drawer mode="side" disableClose="true" opened="true">
        <button class="side-nav__button" mat-menu-item [routerLink]="['/']" [routerLinkActiveOptions]="{exact: true}"
            routerLinkActive="active-link">
            <mat-icon>description</mat-icon>
            <span class="side-nav__button-text">
                Trade Contracts
            </span>
        </button>
        <button class="side-nav__button" mat-menu-item [routerLink]="['executed-confirmation-notices']"
            [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active-link">
            <mat-icon>task</mat-icon>
            <span>
                Executed Confirmation Notices
            </span>
        </button>
        <button class="side-nav__button" mat-menu-item [routerLink]="['trade-exclusions']"
            [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active-link">
            <mat-icon>not_interested</mat-icon>
            <span>
                Trade Exclusions
            </span>
        </button>
        <button class="side-nav__button" mat-menu-item [routerLink]="['internal-review']"
            [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active-link">
            <mat-icon>lan</mat-icon>
            <span>
                Internal Review
            </span>
        </button>
        @if (!isProd || isAdmin()) {
        <hr>
        <button class="side-nav__button" mat-menu-item [routerLink]="['statuses']"
            [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active-link">
            <mat-icon>pending</mat-icon>
            <span>
                Statuses
            </span>
        </button>
        <button class="side-nav__button" mat-menu-item [routerLink]="['users']"
            [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active-link">
            <mat-icon>people</mat-icon>
            <span>
                Users
            </span>
        </button>
        <button class="side-nav__button" mat-menu-item [routerLink]="['departments']"
            [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active-link">
            <mat-icon><span class="material-icons-outlined">
                    business
                </span></mat-icon>
            <span>
                Departments
            </span>
        </button>
        }
    </mat-drawer>
    <mat-drawer-content style="margin-left: 0">
        <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
        <router-outlet *ngIf="!isIframe"></router-outlet>
    </mat-drawer-content>
</mat-drawer-container>